/* Mercavelle — pakketkiezer op de PDP.
   Pakketten, prijzen en kortingspercentages komen uit de Liquid-data in
   mv-pdp-picker.liquid; in dit bestand staat geen enkel bedrag hardcoded. */
(function () {
  var root = document.getElementById('mv-picker');
  var dataEl = document.getElementById('mv-picker-data');
  if (!root || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var types = {};
  data.types.forEach(function (t) { types[t.key] = t; });
  var TIERS = data.tiers || [{ qty: 1, pct: 0, main: '1 stuk', sub: '' }];
  /* Verzendkosten onder de gratis-verzendgrens; bedragen komen uit de Liquid-data. */
  var SHIP = data.shipping || { cost: 0, freeFrom: 0 };

  var ADD_LABEL = 'Start mijn warme avonden';

  var tiersEl = document.getElementById('mv-tiers');
  var progEl = document.getElementById('mv-prog');
  var itemsEl = document.getElementById('mv-items');
  var summaryLines = document.getElementById('mv-summary-lines');
  var saveEl = document.getElementById('mv-save');
  var totalEl = document.getElementById('mv-total');
  var addBtn = document.getElementById('mv-add');
  var noteEl = document.getElementById('mv-add-note');

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var PEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 20h4L20 8l-4-4L4 16z"/></svg>';

  /* state leeft alleen in het geheugen, geen opslag */
  var maxQty = TIERS[TIERS.length - 1].qty;
  var state = { qty: TIERS[0].qty, open: 0, editing: null, items: [] };
  for (var i = 0; i < maxQty; i++) state.items.push({ type: null, color: null });

  /* ---------- rekenwerk ---------- */

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function tierOf(qty) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].qty === qty) return TIERS[i];
    return TIERS[0];
  }

  function pct() { return tierOf(state.qty).pct || 0; }

  /* Shopify rekent de korting per regel en rondt die naar beneden af op hele
     centen. Zo rekenen wij ook, anders wijkt het voorbeeld een cent af van de
     winkelwagen. */
  function discounted(cents) { return cents - Math.floor(cents * pct() / 100); }

  function listFor(key) { return types[key] && types[key].available ? types[key].variants : []; }

  function priceOf(key) { return types[key] ? types[key].price : 0; }

  /* Type dat we gebruiken om de dessins alvast te tonen zolang de klant nog
     geen type koos. Volwassenen en kids hebben dezelfde kleuren. */
  function previewKey(item) {
    if (item.type) return item.type;
    if (types.adult && types.adult.available && types.adult.variants.length) return 'adult';
    if (types.kids && types.kids.available && types.kids.variants.length) return 'kids';
    return null;
  }

  function variantIn(key, color) {
    if (!key || !color) return null;
    var list = listFor(key);
    for (var i = 0; i < list.length; i++) if (list[i].color === color) return list[i];
    return null;
  }

  function variantOf(item) { return item.type ? variantIn(item.type, item.color) : null; }
  function previewVariant(item) { return variantIn(previewKey(item), item.color); }

  function activeItems() { return state.items.slice(0, state.qty); }
  function isDone(item) { return !!(item.type && variantOf(item)); }
  function doneCount() { return activeItems().filter(isDone).length; }
  function isComplete() { return doneCount() === state.qty; }

  function firstOpen() {
    for (var i = 0; i < state.qty; i++) if (!isDone(state.items[i])) return i;
    return -1;
  }

  /* De laagste prijs die nog mogelijk is: wat nog niet gekozen is telt als kids. */
  function totals() {
    var gross = 0;
    var net = 0;
    activeItems().forEach(function (it) {
      var p = it.type ? priceOf(it.type) : lowestPrice();
      gross += p;
      net += discounted(p);
    });
    return { gross: gross, net: net, save: gross - net };
  }

  function shippingFor(net) { return SHIP.cost && net < SHIP.freeFrom ? SHIP.cost : 0; }

  function lowestPrice() {
    var p = null;
    Object.keys(types).forEach(function (k) {
      if (!types[k].available) return;
      if (p === null || types[k].price < p) p = types[k].price;
    });
    return p === null ? 0 : p;
  }

  /* ---------- rendering ---------- */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function renderTiers() {
    tiersEl.innerHTML = '';
    TIERS.forEach(function (t) {
      var laagste = lowestPrice();
      var from = (laagste - Math.floor(laagste * (t.pct || 0) / 100)) * t.qty;
      var btn = el('button', 'mv-tier' + (state.qty === t.qty ? ' is-selected' : ''),
        (t.pct ? '<span class="mv-tier-badge">' + t.pct + '% korting</span>' : '') +
        '<span class="mv-tier-check">' + CHECK + '</span>' +
        '<span class="mv-tier-main">' + escapeHtml(t.main) + '</span>' +
        '<span class="mv-tier-sub">' + escapeHtml(t.sub) + '</span>' +
        '<span class="mv-tier-from">Vanaf</span>' +
        '<span class="mv-tier-price">' + money(from) + '</span>' +
        (SHIP.cost ? (shippingFor(from)
          ? '<span class="mv-tier-ship">+ ' + money(shippingFor(from)) + ' verzendkosten</span>'
          : '<span class="mv-tier-ship is-free">Gratis verzending</span>') : ''));
      btn.type = 'button';
      btn.setAttribute('aria-pressed', state.qty === t.qty ? 'true' : 'false');
      btn.addEventListener('click', function () {
        state.qty = t.qty;
        state.editing = null;
        var next = firstOpen();
        state.open = next < 0 ? state.qty - 1 : next;
        hideNote();
        render();
      });
      tiersEl.appendChild(btn);
    });
  }

  function renderProgress() {
    progEl.innerHTML = '';
    if (state.qty < 2) return;
    progEl.appendChild(el('span', 'mv-prog-text',
      doneCount() + ' van ' + state.qty + ' hoodies gekozen'));
    var bar = el('span', 'mv-prog-bar');
    for (var i = 0; i < state.qty; i++) {
      bar.appendChild(el('span', 'mv-prog-seg' + (isDone(state.items[i]) ? ' is-done' : '')));
    }
    progEl.appendChild(bar);
  }

  function typeButton(item, index, key) {
    var t = types[key];
    var btn = el('button', 'mv-type' + (item.type === key ? ' is-selected' : ''));
    btn.type = 'button';
    btn.setAttribute('aria-pressed', item.type === key ? 'true' : 'false');

    if (!t.available || !t.variants.length) {
      btn.disabled = true;
      btn.classList.add('is-unavailable');
      btn.innerHTML = '<span class="mv-type-name">' + escapeHtml(t.label) + '</span>' +
        '<span class="mv-type-price">Binnenkort</span>';
      return btn;
    }

    btn.innerHTML = '<span class="mv-type-name">' + escapeHtml(t.label) + '</span>' +
      '<span class="mv-type-price">' + money(discounted(t.price)) +
      (pct() ? ' <s>' + money(t.price) + '</s>' : '') + '</span>';

    btn.addEventListener('click', function () {
      if (item.type !== key) {
        item.type = key;
        var kept = variantIn(key, item.color);
        if (!kept || !kept.available) item.color = null;
      }
      afterChoice(index);
    });
    return btn;
  }

  function afterChoice(index) {
    hideNote();
    if (isDone(state.items[index])) {
      state.editing = null;
      var next = firstOpen();
      state.open = next < 0 ? index : next;
    }
    render();
  }

  function renderItem(item, index) {
    var open = index === state.open;
    var done = isDone(item);
    var wrap = el('div', 'mv-item' + (done && !open ? ' is-done' : '') + (open ? ' is-open' : ''));

    var head = el('div', 'mv-item-head');
    head.appendChild(el('span', 'mv-item-badge', done && !open ? CHECK : String(index + 1)));
    head.appendChild(el('span', 'mv-item-title', 'Hoodie ' + (index + 1)));
    if (done && !open) {
      var edit = el('button', 'mv-item-edit', PEN + 'Wijzig');
      edit.type = 'button';
      edit.addEventListener('click', function () {
        state.open = index;
        state.editing = index;
        render();
      });
      head.appendChild(edit);
    }
    wrap.appendChild(head);

    if (done && !open) {
      var v = variantOf(item);
      wrap.appendChild(el('div', 'mv-item-done',
        '<span class="mv-item-thumb"><img src="' + v.image + '" alt="' + escapeAttr(v.color) + '"></span>' +
        '<span class="mv-item-facts">' +
          '<span class="mv-fact"><span class="mv-fact-label">Voor wie?</span>' +
            '<span class="mv-fact-value"><span>' + escapeHtml(types[item.type].label) + '</span></span></span>' +
          '<span class="mv-fact"><span class="mv-fact-label">Dessin</span>' +
            '<span class="mv-fact-value"><span class="mv-fact-sw"><img src="' + v.image + '" alt=""></span>' +
            '<span>' + escapeHtml(v.color) + '</span></span></span>' +
        '</span>'));
      return wrap;
    }

    if (!open) {
      wrap.appendChild(el('div', 'mv-item-todo', 'Nog te kiezen'));
      return wrap;
    }

    var step2 = el('div', 'mv-step' + (item.type ? '' : ' is-waiting'));
    step2.appendChild(el('div', 'mv-step-label', '<span class="mv-step-num">2</span>Voor wie is het?'));
    var typeRow = el('div', 'mv-type-row');
    typeRow.appendChild(typeButton(item, index, 'adult'));
    typeRow.appendChild(typeButton(item, index, 'kids'));
    step2.appendChild(typeRow);
    wrap.appendChild(step2);

    var colorKey = previewKey(item);
    if (colorKey && listFor(colorKey).length) {
      var step3 = el('div', 'mv-step' + (item.color ? '' : ' is-waiting'));
      step3.appendChild(el('div', 'mv-step-label', '<span class="mv-step-num">3</span>Kies je dessin'));

      var grid = el('div', 'mv-swatches');
      listFor(colorKey).forEach(function (variant) {
        var sw = el('button', 'mv-swatch' + (item.color === variant.color ? ' is-selected' : '') +
          (variant.available ? '' : ' is-sold-out'),
          '<img src="' + variant.image + '" alt="' + escapeAttr(variant.color) + '" loading="lazy">' +
          '<span class="mv-swatch-name">' + escapeHtml(variant.color) + '</span>');
        sw.type = 'button';
        sw.title = variant.color;
        sw.setAttribute('aria-label', variant.color);
        sw.setAttribute('aria-pressed', item.color === variant.color ? 'true' : 'false');
        if (!variant.available) sw.disabled = true;
        sw.addEventListener('click', function () {
          item.color = variant.color;
          afterChoice(index);
        });
        grid.appendChild(sw);
      });
      step3.appendChild(grid);
      if (!item.type) {
        step3.appendChild(el('div', 'mv-picker-hint',
          'De dessins zijn voor volwassenen en kids hetzelfde — je kiest hierboven voor wie.'));
      }
      wrap.appendChild(step3);
    }

    return wrap;
  }

  function renderItems() {
    itemsEl.innerHTML = '';
    activeItems().forEach(function (item, i) {
      itemsEl.appendChild(renderItem(item, i));
    });
  }

  function renderSummary() {
    summaryLines.innerHTML = '';
    var t = totals();

    activeItems().forEach(function (item, i) {
      var v = variantOf(item);
      var pv = previewVariant(item);
      var line = el('div', 'mv-sum-line' + (v ? '' : ' is-pending'));

      if (v) {
        line.innerHTML =
          '<span class="mv-sum-thumb"><img src="' + v.image + '" alt=""></span>' +
          '<span class="mv-sum-text">' + escapeHtml(types[item.type].label) + ' · ' + escapeHtml(v.color) + '</span>' +
          '<span class="mv-sum-price">' + money(discounted(priceOf(item.type))) + '</span>';
      } else if (pv) {
        line.innerHTML =
          '<span class="mv-sum-thumb"><img src="' + pv.image + '" alt=""></span>' +
          '<span class="mv-sum-text">' + escapeHtml(pv.color) + ' · nog kiezen voor wie</span>' +
          '<span class="mv-sum-price">—</span>';
      } else {
        line.innerHTML =
          '<span class="mv-sum-thumb is-empty"></span>' +
          '<span class="mv-sum-text">Hoodie ' + (i + 1) + ' — nog te kiezen</span>' +
          '<span class="mv-sum-price">—</span>';
      }
      summaryLines.appendChild(line);
    });

    if (pct() && t.save > 0) {
      saveEl.hidden = false;
      saveEl.textContent = 'Je bespaart ' + money(t.save) + ' (' + pct() + '%)';
    } else {
      saveEl.hidden = true;
    }

    var ship = shippingFor(t.net);
    var shipRow = document.getElementById('mv-ship-row');
    if (!shipRow && totalEl.parentNode) {
      shipRow = el('div', 'mv-ship-row');
      shipRow.id = 'mv-ship-row';
      totalEl.parentNode.parentNode.insertBefore(shipRow, totalEl.parentNode);
    }
    if (shipRow) {
      shipRow.hidden = !ship;
      shipRow.innerHTML = '<span>Verzendkosten</span><span>' + money(ship) + '</span>';
    }

    totalEl.innerHTML = isComplete()
      ? money(t.net + ship)
      : 'vanaf ' + money(t.net + ship);

    addBtn.disabled = !isComplete();
    addBtn.textContent = isComplete() ? ADD_LABEL : 'Maak je keuze compleet';
  }

  /* De vaste balk onderaan loopt mee met de keuze. */
  function renderStickyBar() {
    var bar = document.querySelector('.sticky-bar');
    if (!bar) return;
    var name = bar.querySelector('.sname');
    var price = bar.querySelector('.sprice');
    var cta = bar.querySelector('.mv-sticky-cta');
    var img = bar.querySelector('img');
    var t = totals();
    var firstDone = activeItems().filter(isDone)[0];

    if (name) {
      name.textContent = state.qty + ' hoodie' + (state.qty > 1 ? 's' : '') +
        (pct() ? ' · ' + pct() + '% korting' : '');
    }
    if (price) {
      price.textContent = (isComplete() ? '' : 'Vanaf ') + money(t.net);
    }
    if (img && firstDone) {
      img.src = variantOf(firstDone).image;
      img.removeAttribute('width');
      img.removeAttribute('height');
    }
    if (cta) {
      var next = firstOpen();
      cta.textContent = isComplete()
        ? ADD_LABEL
        : (state.qty - doneCount() === 1 ? 'Kies laatste hoodie' : 'Kies hoodie ' + (next + 1));
      cta.dataset.complete = isComplete() ? 'true' : 'false';
    }
  }

  function render() {
    renderTiers();
    renderProgress();
    renderItems();
    renderSummary();
    renderStickyBar();
  }

  /* ---------- winkelwagen ---------- */

  function hideNote() { noteEl.hidden = true; noteEl.innerHTML = ''; }

  function showNote(html, isError) {
    noteEl.hidden = false;
    noteEl.className = 'mv-add-note' + (isError ? ' is-error' : ' is-ok');
    noteEl.innerHTML = html;
  }

  function addToCart(button) {
    if (!isComplete()) return;

    var payload = {
      items: activeItems().map(function (item) {
        return { id: variantOf(item).id, quantity: 1 };
      })
    };

    var label = button.textContent;
    button.textContent = 'Bezig…';
    if (button.tagName === 'BUTTON') button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Toevoegen mislukt');
          return body;
        });
      })
      .then(function () {
        /* direct door naar de checkout; de knop blijft op 'Bezig…' tot de
           navigatie begint, zodat er niet twee keer geklikt kan worden */
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        button.textContent = label;
        if (button.tagName === 'BUTTON') button.disabled = false;
        showNote('Er ging iets mis: ' + escapeHtml(err.message), true);
      });
  }

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled) return;
    addToCart(addBtn);
  });

  /* De knop in de vaste balk: afronden als alles gekozen is, anders naar de kiezer. */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest ? e.target.closest('.mv-sticky-cta') : null;
    if (!cta) return;
    if (cta.dataset.complete === 'true') {
      e.preventDefault();
      addToCart(cta);
    }
  });

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  render();
})();
